// @ts-ignore
/* eslint-disable */
import { request } from "umi";

/** 获取登录用户 获取登录用户信息 POST /system/login/getLoginUser */
export async function getLoginUser(options?: { [key: string]: any }) {
  return request<API.UserInfo>("/system/login/getLoginUser", {
    method: "POST",
    ...(options || {}),
  });
}

/** 获取路由信息 获取路由信息 POST /system/login/getRouters */
export async function getRouters(options?: { [key: string]: any }) {
  return request<API.RouterVo[]>("/system/login/getRouters", {
    method: "POST",
    ...(options || {}),
  });
}

/** 登录 登录 POST /system/login/login */
export async function login(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.loginParams,
  options?: { [key: string]: any }
) {
  return request<API.AjaxResult>("/system/login/login", {
    method: "POST",
    params: {
      ...params,
      loginReq: undefined,
      ...params["loginReq"],
    },
    ...(options || {}),
  });
}

/** 开发登录 开发登录 POST /system/login/loginDev */
export async function loginDev(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.loginDevParams,
  options?: { [key: string]: any }
) {
  return request<API.AjaxResult>("/system/login/loginDev", {
    method: "POST",
    params: {
      ...params,
      loginReq: undefined,
      ...params["loginReq"],
    },
    ...(options || {}),
  });
}

/** 退出登录 用户退出登录 POST /system/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<API.AjaxResult>("/system/login/outLogin", {
    method: "POST",
    ...(options || {}),
  });
}

/** 企业微信登录 企业微信登录 POST /system/login/qywxLogin */
export async function qywxLogin(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.qywxLoginParams,
  options?: { [key: string]: any }
) {
  return request<API.AjaxResult>("/system/login/qywxLogin", {
    method: "POST",
    params: {
      ...params,
      loginReq: undefined,
      ...params["loginReq"],
    },
    ...(options || {}),
  });
}
